import { render, staticRenderFns } from "./TicketsBasicInfo.vue?vue&type=template&id=0bc8577e&scoped=true"
import script from "./TicketsBasicInfo.vue?vue&type=script&lang=js"
export * from "./TicketsBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./TicketsBasicInfo.vue?vue&type=style&index=0&id=0bc8577e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc8577e",
  null
  
)

export default component.exports